import React from 'react'
import Wix from 'Wix';
import { connect } from 'react-redux'
import { ShapeStyle, ShapeContainer } from './style'
import { convertStyle, getDiffToMobileConvert, convertMobileUmitableFields } from '../../../../../editSlide/api/converter'
import { getBackgroundGradient } from '../../../../../Utils/utils';
import { getRightPropertyValue } from '../../../../../Utils/helpers';
import { RenderSvgShape } from '../../../../../Utils/svgShapes';

class ShapeCaption extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            shapeStyle: {
                backgroundColor: null,
                height: null,
                position: null,
                width: null,
            },
        }
    }


    componentWillMount() {
        //     const deviceType = Wix.Utils.getDeviceType()
        //     this.setState({
        //         shapeStyle: this.getShapeStyle(this.props.caption, deviceType)
        //     })
    }

    componentWillReceiveProps(newProps) {
        // const deviceType = Wix.Utils.getDeviceType()
        // this.setState({
        //     shapeStyle: this.getShapeStyle(newProps.caption, deviceType)
        // })
    }

    getShapeStyle(caption, viewType) {
        const isMobile = viewType === 'mobile'
        const desktopDims = this.props.slide === undefined ? { width: this.props.widgetDimensions.editedWidth, height: this.props.widgetDimensions.editedHeight } : { width: this.props.slide.editedWidth, height: this.props.slide.editedHeight }
        const mobileDims = { width: this.props.widgetDimensions.mobileWidth, height: this.props.widgetDimensions.mobileHeight }
        if (viewType === 'mobile') {
            const { mobileDiffW, mobileDiffH } = getDiffToMobileConvert(
                this.props.widgetDimensions.width,
                this.props.widgetDimensions.height,
                this.props.widgetDimensions.mobileWidth,
                this.props.widgetDimensions.mobileHeight,
            )
            const maxDiff = mobileDiffW > mobileDiffH ? mobileDiffW : mobileDiffH
            caption = convertMobileUmitableFields(_.cloneDeep(caption), mobileDiffW, mobileDiffH, maxDiff)
        }
        let borderRadiusProperty, borderWidthProperty, widthProperty, positionProperty, heightProperty;

        switch (viewType) {
            case 'desktop':
                borderRadiusProperty = 'borderRadius';
                borderWidthProperty = 'borderWidth';
                widthProperty = 'width';
                heightProperty = 'height';
                positionProperty = 'position';
                break;

            case 'mobile':
                borderRadiusProperty = 'mobileBorderRadius';
                borderWidthProperty = 'mobileBorderWidth';
                widthProperty = 'mobileWidth';
                heightProperty = 'mobileHeight';
                positionProperty = 'mobilePosition';
                break;
        }


        // const captionStyle = {
        //     backgroundColor: caption.backgroundColor,
        //     borderColor: caption.borderColor,
        //     borderRadius: caption[borderRadiusProperty],
        //     borderWidth: caption[borderWidthProperty],
        //     height: caption[heightProperty],
        //     shadow: !caption.hasShadow ? '' : `${caption.shadow.x}px ${caption.shadow.y}px ${caption.shadow.blur}px ${caption.shadow.size}px ${caption.shadow.color}`,
        //     position: {
        //         x: caption.boxId === '' ? caption[positionProperty].x : caption[positionProperty].relativeX,
        //         y: caption.boxId === '' ? caption[positionProperty].y : caption[positionProperty].relativeY
        //     },
        //     width: caption[widthProperty],
        //     zIndex: caption.layer + 200,
        // }

        const needMobileConvert = caption.needMobileConvert || false

        let captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, caption, 1, '', true, needMobileConvert)
        if (caption.boxId !== '' && isMobile && caption.mobilePosition && caption.mobilePosition.relativeX == undefined) {
            const clonedCaption = _.cloneDeep(caption)
            delete clonedCaption.mobilePosition
            const convertedPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, clonedCaption, 1, '', true, needMobileConvert)
            captionPosition = {
                ...captionPosition,
                relativeX: convertedPosition.relativeX,
                relativeY: convertedPosition.relativeY
            }
        }
        const xProp = caption.boxId === '' ? 'x' : 'relativeX'
        const yProp = caption.boxId === '' ? 'y' : 'relativeY'

        const captionStyle = {
            backgroundColor: caption.backgroundColor,
            borderColor: caption.borderColor,
            borderRadius: getRightPropertyValue(desktopDims, mobileDims, 'borderRadius', isMobile, caption, 1, '', true, needMobileConvert),
            borderWidth: getRightPropertyValue(desktopDims, mobileDims, 'borderWidth', isMobile, caption, 1, '', true, needMobileConvert),
            height: getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, caption, 1, '', true, needMobileConvert),
            shadow: !caption.hasShadow ? '' : `${caption.shadow.x}px ${caption.shadow.y}px ${caption.shadow.blur}px ${caption.shadow.size}px ${caption.shadow.color}`,
            position: {
                x: captionPosition[xProp],
                y: captionPosition[yProp]
            },
            width: getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, caption, 1, '', true, needMobileConvert),
            zIndex: caption.layer + 200,
        }


        // в мобильной версии капча уезжала наверх, видимо не учитывалась конвертация
        // if (captionStyle.position.x > this.props.settingsReducer.widgetDimensions[widthProperty]) {
        //     captionStyle.position.x = 0
        // }

        // if (captionStyle.position.y > this.props.settingsReducer.widgetDimensions[heightProperty]) {
        //     captionStyle.position.y = 0
        // }

        return captionStyle
    }


    render() {
        const caption = this.props.caption
        const deviceType = Wix.Utils.getDeviceType()
        const isMobile = deviceType === 'mobile'
        const hasCustomShape = caption.shape != 'rectangle' && caption.shape != undefined

        const shapeStyle = this.getShapeStyle(this.props.caption, deviceType)
        const unicalClassName = this.props.unicalClassName ? `caption-${this.props.slideIndex}-${this.props.captionIndex}-${this.props.unicalClassName} ` : ''
        const shapeContainerStyles = {
            left: shapeStyle.position.x,
            top: shapeStyle.position.y,
            zIndex: shapeStyle.zIndex
        }
        const innerShapeStyles = hasCustomShape ? {
            border: 'none',
            width: shapeStyle.width,
            height: shapeStyle.height
        } : {
            width: shapeStyle.width,
            height: shapeStyle.height,
            background: getBackgroundGradient({ backgroundColor: shapeStyle.backgroundColor }),
            borderColor: shapeStyle.borderColor,
            borderRadius: `${shapeStyle.borderRadius.leftTop}px ${shapeStyle.borderRadius.rightTop}px ${shapeStyle.borderRadius.rightBottom}px ${shapeStyle.borderRadius.leftBottom}px`,
            boxShadow: shapeStyle.shadow,
            borderWidth: shapeStyle.borderWidth,
        }



        const borderRadius = shapeStyle.borderRadius
        const borderWidth = shapeStyle.borderWidth
        const borderColor = shapeStyle.borderColor

        let svgShadow = ''

        const desktopDims = { width: this.props.widgetDimensions.editedWidth, height: this.props.widgetDimensions.editedHeight }
        const mobileDims = { width: this.props.widgetDimensions.mobileWidth, height: this.props.widgetDimensions.mobileHeight }
        if (caption.hasShadow) {
            svgShadow = `drop-shadow(${getRightPropertyValue(desktopDims, mobileDims, 'x', isMobile, caption.shadow)}px `
                + `${getRightPropertyValue(desktopDims, mobileDims, 'y', isMobile, caption.shadow)}px `
                + `${getRightPropertyValue(desktopDims, mobileDims, 'blur', isMobile, caption.shadow)}px `
                + `${caption.shadow.color})`
        }
        const blur = getRightPropertyValue(desktopDims, mobileDims, 'blur', isMobile, caption)
        const glassEffect = getRightPropertyValue(desktopDims, mobileDims, 'glassEffect', isMobile, caption)
        return (
            <ShapeContainer
                id={`caption-${this.props.caption.index}`}
                style={{ ...shapeContainerStyles, ...innerShapeStyles }}
                className={`caption-container-${this.props.slideIndex}-${this.props.captionIndex} animated animate-${this.props.slideIndex}-${this.props.captionIndex} caption-${this.props.slideIndex}-${this.props.captionIndex} caption-content ${unicalClassName}`}
                // position={shapeStyle.position}
                // zIndex={shapeStyle.zIndex}
                // position={this.state.shapeStyle.position}
                data-animation-in={this.props.animationIn || 'null'}
                blur={blur}
                glassEffect={glassEffect || 0}
                grayscaleEffect={caption.grayscaleEffect || 0}
                invertEffect={caption.invertEffect || 0}
                effectType={caption.effectType || 'element'}
                hasCustomShape={hasCustomShape}
            >
                {
                    hasCustomShape ?
                        <div
                            className={`caption-${this.props.slideIndex}-${this.props.captionIndex} caption-content ${unicalClassName}`}
                            style={{
                                width: innerShapeStyles.width,
                                height: innerShapeStyles.height,
                            }}
                        >
                            <RenderSvgShape
                                type={caption.shape}
                                dimensions={{ width: '100%', height: '100%' }}
                                backgroundColor={caption.backgroundColor}
                                backgroundColorType={caption.backgroundColor.type}
                                uid={caption.id}
                                borderRadius={borderRadius.leftTop || borderRadius.borderRadius}
                                stroke={borderWidth}
                                strokeColor={borderColor}
                                strokeType={caption.stroke || 'solid'}
                                glassBlur={caption.glassBlur}
                                style={{
                                    filter: svgShadow,
                                }}
                            />
                        </div>
                        :
                        <ShapeStyle

                            // style={innerShapeStyles}
                            className={``}
                        // {...shapeStyle}
                        // {...this.state.shapeStyle}
                        />
                }

            </ShapeContainer>
        )
    }
}


// function mapStateToProps(state) {
//     return state
// }

// export default connect(mapStateToProps)(ShapeCaption)
export default ShapeCaption